import {createBrowserRouter, Navigate} from "react-router-dom";

import Layout from "@/components/Layout/Layout";
import DetailMassification from "@/page/DetailMassification/DetailMassification";
import DetailOperationCommerciale from "@/page/DetailOperationCommerciale/DetailOperationCommerciale";
import MesCommandesOperationCommerciale from "@/page/MonCompte/MesCommandesOperationCommerciale";
import MonCompte from "@/page/MonCompte/MonCompte";

import Accueil from "../page/Accueil/Accueil";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Navigate to="/co-deals" replace />,
    },
    {
      path: "/co-deals",
      children: [
        {
          path: "",
          element: (
            <Layout>
              <Accueil />
            </Layout>
          ),
        },
        {
          path: "mon_compte",
          element: (
            <Layout>
              <MonCompte />
            </Layout>
          ),
        },
        {
          path: "detail_massification",
          element: (
            <Layout>
              <DetailMassification />
            </Layout>
          ),
        },
        {
          path: "operation_commerciale/:id",
          element: (
            <Layout>
              <DetailOperationCommerciale />
            </Layout>
          ),
        },
        {
          path: "mon_compte/operation_commerciale/:id",
          element: (
            <Layout>
              <MesCommandesOperationCommerciale />
            </Layout>
          ),
        },
      ],
    },
    {
      path: "/live",
    },
  ],
  {},
);
